import React, { Component } from 'react'
import axios from 'axios';
import { URL, idEmpresa, getAuthorizationHeader } from "../../constans/constants";

export default class ModalReasignarTramite extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isProcessing: true,
            miembros: [],
            miembro: null
        };
        this.dialogRef = React.createRef();
    }

    componentDidMount() {
        // Manejar el estado inicial del modal
        if (this.props.isOpen) {
            this.abrirModal();
        }
    }

    componentDidUpdate(prevProps) {
        // Detectar cambios en isOpen para abrir/cerrar el modal
        if (this.props.isOpen !== prevProps.isOpen) {
            if (this.props.isOpen) {
                this.cargarMiembros();
                this.abrirModal();
            } else {
                this.cerrarModalConAnimacion();
            }
        }
    }

    abrirModal = () => {
        if (this.dialogRef.current && !this.dialogRef.current.open) {
            this.dialogRef.current.showModal();
        }
    }

    cerrarModal = () => {
        if (this.dialogRef.current && this.dialogRef.current.open) {
            this.dialogRef.current.close();
        }
    }

    cerrarModalConAnimacion = () => {
        if (this.dialogRef.current && this.dialogRef.current.open) {
            this.dialogRef.current.style.scale = '0';
            setTimeout(() => {
                if (this.dialogRef.current && this.dialogRef.current.open) {
                    this.dialogRef.current.close();
                }
            }, 300);
        }
    }

    manejarCancelar = () => {
        this.cerrarModalConAnimacion();
        setTimeout(() => {
            this.props.cerrarModal();
        }, 300);
    }

    manejarConfirmar = () => {
        const { miembro } = this.state;

        if (miembro) {
            this.props.onConfirmar(miembro); // Llama al método del padre
            this.cerrarModalConAnimacion();
            setTimeout(() => {
                this.props.cerrarModal(); // Notifica al padre que se cerró
            }, 300);
        }
    };

    cargarMiembros = () => {
        axios
            .get(URL + "miembros/empresa/" + idEmpresa(), getAuthorizationHeader())
            .then((response) => {
                if (!response.data.error && Array.isArray(response.data.datos)) {
                    const miembrosFormateados = response.data.datos.map((miembro) => ({
                        id: miembro.id,
                        nombreApellido: miembro.userDetails?.usuario?.apellidos  + " " + miembro.userDetails?.usuario?.nombre?? 'Sin nombre'
                    }));
                    this.setState({ miembros: miembrosFormateados });
                }
            })
            .catch((error) => {
                console.error("Error al cargar miembros:", error);
            });
    }

    handleChangeMiembro = (e) => {
        const name = e.target.name;
        const val = e.target.value;
        this.setState({
            [name]: val,
            isProcessing: false
        });
    }

    render() {
        return (
            <div className="component-modal">
                <dialog
                    className="modal"
                    id="modal-reasignar"
                    ref={this.dialogRef}
                    onClose={this.manejarCancelar}
                >
                    <div className="modal-content">
                        <div className="modal-body">
                            <h3 className="title">
                                Reasignar tramite
                            </h3>
                            <p className="msg">Seleccione un usuario de la lista para reasignar este tramite</p>

                            <div className="card">
                                <div className="form-group">
                                    <select className="form-select" name="miembro" id="miembro" placeholder="" value={this.state.selectedMiembro} onChange={this.handleChangeMiembro}>
                                        <option key="" value="" selected></option>
                                        {this.state.miembros.map((elemento) => (
                                            <option key={elemento.id} value={elemento.id}>
                                                {elemento.nombreApellido}
                                            </option>
                                        ))}
                                    </select>
                                    <label htmlFor="miembro" className="form-label"> Seleccionar miembro </label>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                className="btn-medium btn-base-outline"
                                id="close-modal"
                                type="button"
                                onClick={this.manejarCancelar}
                            >
                                Cancelar
                            </button>

                            <button
                                className="btn-medium btn-primary"
                                onClick={this.manejarConfirmar}
                                disabled={this.state.isProcessing}
                            >
                                Reasignar
                            </button>
                        </div>
                    </div>
                </dialog>
            </div>
        )
    }
}
